import { spaceTypes } from '../spaceTypes';
import countries from 'constants/countries';
import { getSize, getInOfficeHeadcountBasedQuantites, getFixedQuantities } from './utils';

export const closedcollaboration = [
  {
    id: 8,
    name: 'spaceTypes.closeCollaboration.phone',
    displayOrder: 1,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(6.0, 5.0),
      [countries.UK]: getSize(6.0, 5.0),
      [countries.FR]: getSize(1.5, 1.8),
      [countries.EU]: getSize(2.0, 3.5),
      [countries.DE]: getSize(2.0, 3.5),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(30, 25, 20),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(30, 25, 60),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(30, 25, 20),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(20, 30, 25),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(20, 30, 25),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818107/insite/qa/spaces/lhuncpyeyr1czmtfpnlk.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818107/insite/qa/spaces/lhuncpyeyr1czmtfpnlk.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818107/insite/qa/spaces/lhuncpyeyr1czmtfpnlk.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818107/insite/qa/spaces/lhuncpyeyr1czmtfpnlk.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818107/insite/qa/spaces/lhuncpyeyr1czmtfpnlk.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 9,
    name: 'spaceTypes.closeCollaboration.huddle',
    displayOrder: 2,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(12.0, 10.0),
      [countries.UK]: getSize(12.0, 10.0),
      [countries.FR]: getSize(2.6, 3.2),
      [countries.EU]: getSize(3.5, 4.0),
      [countries.DE]: getSize(3.5, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(30, 25, 20),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(30, 25, 60),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(30, 25, 20),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(20, 30, 25),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(20, 30, 25),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499750/insite/qa/spaces/iywlnthneudhoygudq3w.png',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499750/insite/qa/spaces/iywlnthneudhoygudq3w.png',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499750/insite/qa/spaces/iywlnthneudhoygudq3w.png',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499750/insite/qa/spaces/iywlnthneudhoygudq3w.png',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499750/insite/qa/spaces/iywlnthneudhoygudq3w.png',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 10,
    name: 'spaceTypes.closeCollaboration.small',
    displayOrder: 3,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(15.0, 10.0),
      [countries.UK]: getSize(15.0, 10.0),
      [countries.FR]: getSize(3.0, 4.0),
      [countries.EU]: getSize(4.0, 4.0),
      [countries.DE]: getSize(4.0, 4.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(50, 50, 100),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(50, 50, 50),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818108/insite/qa/spaces/tt5cc2jnf5eueqpxgm3d.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818108/insite/qa/spaces/tt5cc2jnf5eueqpxgm3d.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818108/insite/qa/spaces/tt5cc2jnf5eueqpxgm3d.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818108/insite/qa/spaces/tt5cc2jnf5eueqpxgm3d.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818108/insite/qa/spaces/tt5cc2jnf5eueqpxgm3d.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 11,
    name: 'spaceTypes.closeCollaboration.medium',
    displayOrder: 4,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(20.0, 15.0),
      [countries.UK]: getSize(20.0, 15.0),
      [countries.FR]: getSize(3.5, 5.7),
      [countries.EU]: getSize(4.0, 5.25),
      [countries.DE]: getSize(4.0, 5.25),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(75, 75, 75),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(75, 75, 150),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(75, 75, 75),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(75, 75, 75),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(75, 75, 75),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818109/insite/qa/spaces/qjujv5wn7yc8ujazmoav.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818109/insite/qa/spaces/qjujv5wn7yc8ujazmoav.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818109/insite/qa/spaces/qjujv5wn7yc8ujazmoav.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818109/insite/qa/spaces/qjujv5wn7yc8ujazmoav.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818109/insite/qa/spaces/qjujv5wn7yc8ujazmoav.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 265,
    name: 'spaceTypes.closeCollaboration.large',
    displayOrder: 5,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(20.0, 20.0),
      [countries.UK]: getSize(20.0, 20.0),
      [countries.FR]: getSize(4.6, 6.5),
      [countries.EU]: getSize(5.0, 7.0),
      [countries.DE]: getSize(5.0, 7.0),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(125, 125, 125),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(125, 125, 125),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(125, 125, 125),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(125, 125, 125),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(125, 125, 125),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818130/insite/qa/spaces/nsl5ayhfmoisews00meq.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818130/insite/qa/spaces/nsl5ayhfmoisews00meq.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818130/insite/qa/spaces/nsl5ayhfmoisews00meq.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818130/insite/qa/spaces/nsl5ayhfmoisews00meq.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818130/insite/qa/spaces/nsl5ayhfmoisews00meq.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 12,
    name: 'spaceTypes.closeCollaboration.xl',
    displayOrder: 6,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(25.0, 24.0),
      [countries.UK]: getSize(25.0, 24.0),
      [countries.FR]: getSize(5.5, 10.0),
      [countries.EU]: getSize(7.0, 7.15),
      [countries.DE]: getSize(7.0, 7.15),
    },
    quantity: {
      [countries.US]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.UK]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.FR]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.EU]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
      [countries.DE]: getInOfficeHeadcountBasedQuantites(150, 150, 150),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818378/insite/prod/spaces/d99ykamgwahp0iixfpbl.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818378/insite/prod/spaces/d99ykamgwahp0iixfpbl.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818378/insite/prod/spaces/d99ykamgwahp0iixfpbl.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818378/insite/prod/spaces/d99ykamgwahp0iixfpbl.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1556818378/insite/prod/spaces/d99ykamgwahp0iixfpbl.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
  {
    id: 266,
    name: 'spaceTypes.closeCollaboration.trainingRoom',
    displayOrder: 8,
    spaceTypeId: spaceTypes.closedcollaboration.id,
    size: {
      [countries.US]: getSize(25.0, 20.0),
      [countries.UK]: getSize(25.0, 20.0),
      [countries.FR]: getSize(1.2, 1.2),
      [countries.EU]: getSize(5.0, 7.0),
      [countries.DE]: getSize(5.0, 7.0),
    },
    quantity: {
      [countries.US]: getFixedQuantities(0),
      [countries.UK]: getFixedQuantities(0),
      [countries.FR]: getFixedQuantities(0),
      [countries.EU]: getFixedQuantities(0),
      [countries.DE]: getFixedQuantities(0),
    },
    imageUrl: {
      [countries.US]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499763/insite/qa/spaces/anjxhqxbniho7atqnd5r.jpg',
      [countries.UK]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499763/insite/qa/spaces/anjxhqxbniho7atqnd5r.jpg',
      [countries.FR]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499763/insite/qa/spaces/anjxhqxbniho7atqnd5r.jpg',
      [countries.EU]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499763/insite/qa/spaces/anjxhqxbniho7atqnd5r.jpg',
      [countries.DE]:
        'https://res.cloudinary.com/jll-am-tenantrep/image/upload/v1554499763/insite/qa/spaces/anjxhqxbniho7atqnd5r.jpg',
    },
    countries: [countries.US, countries.UK, countries.FR, countries.EU, countries.DE],
  },
];
